export default __webpack_public_path__ + "static/problem_1-39c10a366f239e23661c0e75a252171d.png";